// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4080ede","239":"a1e5c3d0","732":"a780ab4b"}[chunkId] + ".chunk.js";
};